export const getHrefTarget = (href: string | undefined): string | undefined =>
  (href ?? "/")[0] === "/" ? undefined : "_blank";

export const getHrefRel = (href: string | undefined): string | undefined =>
  (href ?? "/")[0] === "/" ? undefined : "noopener noreferrer";
